import FacebookIcon from '@/assets/icons/facebook_wb.svg?react';
import InstagramIcon from '@/assets/icons/instagram_wb.svg?react';
import TikTokIcon from '@/assets/icons/tik-tok_wb.svg?react';
import {type LocalizationKey} from '@/shared/services/i18n';
import {localizeHref} from '@/sync/lib/localizeHref';

export type FooterLink = {
  link: string;
  title?: string;
  titleKey?: LocalizationKey;
};

/**
 * Functions rather than constants: `localizeHref` reads the active language at
 * call time, so a module-level array would freeze whatever language happened to
 * be set when the module was first imported — which is before `i18n.init()`
 * resolves, and once for the whole build during prerender.
 */
export function getLoginFooterGroup(): FooterLink[] {
  return [
    {
      titleKey: 'terms_of_service',
      link: localizeHref('/:lang?/terms'),
    },
    {
      titleKey: 'privacy_policy',
      link: localizeHref('/:lang?/privacy'),
    },
    {
      titleKey: 'community_guidelines_link',
      link: localizeHref('/:lang?/community-guidelines'),
    },
    {
      titleKey: 'ambassador_public_agreement',
      link: localizeHref('/:lang?/ambassador-public-agreement'),
    },
    {
      titleKey: 'footer_cookie_policy_title',
      link: localizeHref('/:lang?/cookie-policy'),
    },
  ];
}

export function getLoginFooterInc(): FooterLink[] {
  return [
    {
      titleKey: 'terms_of_service',
      link: localizeHref('/:lang?/terms-of-service'),
    },
    {
      titleKey: 'privacy_policy',
      link: localizeHref('/:lang?/privacy-policy'),
    },
    {
      titleKey: 'footer_cookie_policy_title',
      link: localizeHref('/:lang?/cookie-policy'),
    },
    {
      titleKey: 'community_guidelines_link',
      link: localizeHref('/:lang?/community-guidelines'),
    },
    {
      titleKey: 'ambassador_public_agreement',
      link: localizeHref('/:lang?/ambassador-public-agreement'),
    },
  ];
}

export const LOGIN_FOOTER_ICONS = [
  {
    icon: FacebookIcon,
    link: 'https://www.facebook.com/bumpy.inc/',
  },
  {
    icon: InstagramIcon,
    link: 'https://www.instagram.com/bumpy.app',
  },
  {
    icon: TikTokIcon,
    link: 'https://www.tiktok.com/@bumpy.app',
  },
];
